module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start05-80e4912723838367577879d28eac9692.gif";